import { api } from '../utils/api';

export interface DatabaseStats {
  database: string;
  driver: string;
  version: string;
  tables_count: number;
  size_mb: number;
}

export interface BackupItem {
  filename: string;
  extension: string;
  size_bytes: number;
  size_formatted: string;
  created_at: string;
  created_at_human: string;
  timestamp: number;
}

export interface BackupsResponse {
  stats: DatabaseStats;
  backups: BackupItem[];
}

export interface CreateBackupResponse {
  message: string;
  backup: BackupItem;
}

/**
 * Obtiene las estadísticas de la base de datos y la lista de copias de seguridad.
 */
export async function getBackupsInfo(): Promise<BackupsResponse> {
  const { data } = await api.get<BackupsResponse>('/backups');
  return data;
}

/**
 * Solicita al servidor generar un nuevo respaldo de la base de datos.
 */
export async function createBackup(): Promise<CreateBackupResponse> {
  const { data } = await api.post<CreateBackupResponse>('/backups');
  return data;
}

/**
 * Descarga una copia de seguridad en formato .zip o .sql.
 */
export async function downloadBackup(filename: string, format: 'zip' | 'sql' = 'zip'): Promise<void> {
  const response = await api.get(`/backups/${encodeURIComponent(filename)}/download`, {
    params: { format },
    responseType: 'blob',
  });

  const contentType = format === 'sql' ? 'application/sql' : 'application/zip';
  const downloadName = format === 'sql'
    ? (filename.replace(/\.zip$/i, '') + '.sql')
    : filename;

  const blob = new Blob([response.data], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = downloadName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

/**
 * Elimina una copia de seguridad almacenada en el servidor.
 */
export async function deleteBackup(filename: string): Promise<{ message: string }> {
  const { data } = await api.delete<{ message: string }>(`/backups/${encodeURIComponent(filename)}`);
  return data;
}
